<template>
  <div class="add-expense">
    <section class="expense-section">
      <div class="expense-section-header">
        <span class="expense-section-title">餐费/比例</span>
        <span class="expense-balance">
          YTD餐费余额：<strong>{{ budgetRes }}</strong>{{ isNaN(budgetRes) ? '' : '元' }}
        </span>
      </div>

      <div class="expense">
        <van-field
          v-model="diner_amount"
          type="number"
          label="预计餐费"
          :disabled="!editable"
          required
        />
        <div class="expense-summary">
          <span>元</span>
          <span>
            共{{ totalPeople }}人 · 人均<strong>{{
              totalPeople ? (diner_amount / totalPeople).toFixed(2) : '0.00'
            }}</strong>元
          </span>
        </div>
      </div>

      <div v-if="showCostProportion" class="cost_proportion">
        <div class="cost-proportion-title">分产品比例</div>
        <van-field
          v-for="(item, index) in costProportion"
          :key="index"
          v-model="costProportionSubmit[index].cost_proportion"
          :label="item.product_name"
          type="number"
          :disabled="!editable"
        >
          <template #button> % </template>
        </van-field>
      </div>
    </section>

    <section class="expense-section">
      <div class="expense-section-header">
        <span class="expense-section-title">用餐医生</span>
        <span class="expense-section-count">{{ doctors.length }}人</span>
      </div>
      <div class="people-list">
        <div
          v-for="(item, index) in doctors"
          :key="index"
          class="input-style"
        >
          <div class="input-border">
            <span>{{ item.physician_name }}</span>
            <span class="input-mini-words">{{ item.institution_name }}</span>
          </div>
          <van-icon
            v-if="editable"
            name="cross"
            color="#22201f"
            class="delete-icon"
            @click="removeDoctor(index)"
          />
        </div>
      </div>
      <div v-if="editable" class="people-action">
        <van-button
          type="info"
          round
          size="small"
          plain
          color="#aa341b"
          @click="showDoctorSelect = true"
        >
          <van-icon name="add-o" />
          添加医生
        </van-button>
      </div>
    </section>

    <section class="expense-section">
      <div class="expense-section-header">
        <span class="expense-section-title">用餐同事</span>
        <span class="expense-section-count">{{ colleagues.length }}人</span>
      </div>
      <div class="people-list">
        <div
          v-for="(item, index) in colleagues"
          :key="index"
          class="input-style"
        >
          <div class="input-border">
            <span>{{ item.user_name }}</span>
            <span class="input-mini-words">{{ item.position }}</span>
          </div>
          <van-icon
            v-if="editable"
            name="cross"
            color="#22201f"
            class="delete-icon"
            @click="removeColleague(index)"
          />
        </div>
      </div>
      <div v-if="editable" class="people-action">
        <van-button
          type="info"
          round
          size="small"
          plain
          color="#aa341b"
          @click="showSelectColleague = true"
        >
          <van-icon name="add-o" />
          添加同事
        </van-button>
      </div>
    </section>
    <DoctorListSelectAllAndNew
      v-if="showDoctorSelect"
      :multiple-mode="true"
      :default-selected-list="doctors"
      @close="showDoctorSelect = false"
      @select="handleSelectDoctor"
    />
    <MealCompanionUserSelectField
      v-model="showSelectColleague"
      :list-value="colleagues"
      @ok="handleSelectColleague"
    />
  </div>
</template>

<script>
import MealCompanionUserSelectField from '@/components/form/MealCompanionUserSelectField.vue';
import DoctorListSelectAllAndNew from '@/components/DoctorListSelectAllAndNew.vue';
import {getLocalStorage} from '@/utils';
export default {
  name: 'AddExpense',
  components: {DoctorListSelectAllAndNew, MealCompanionUserSelectField},
  props: [
    'showAddExpense',
    'showCostProportion',
    'costProportion',
    'defDoctors',
    'defColleagues',
    'budgetRes',
    'callProducts',
    'defDinerAmount',
    'defEditable',
  ],
  data() {
    return {
      // 在这里定义数据
      diner_amount: 0,
      showDoctorSelect: false,
      showSelectColleague: false,
      doctors: [],
      colleagues: [],
      myColleagues: [],
      myDoctors: [],
      costProportionSubmit: [],
      defaultCallProducts: [],
    };
  },
  computed: {
    editable() {
      return this.defEditable !== false;
    },
    totalPeople() {
      return this.doctors.length + this.colleagues.length;
    },
  },
  watch: {
    costProportion(newVal) {
      console.log('cnm---->1', newVal);
      this.costProportionSubmit = newVal.map((item, index) => {
        return {
          product_id: item.product_id,
          product_name: item.product_name,
          cost_proportion:
            Math.floor(100 / newVal.length) +
            (index < 100 % newVal.length ? 1 : 0),
        };
      });
    },
    defDoctors(newVal) {
      this.doctors = newVal;
      this.emitDraftChange();
    },
    defColleagues(newVal) {
      this.colleagues = newVal;
      this.emitDraftChange();
    },
    defDinerAmount(newVal) {
      this.diner_amount = newVal;
      this.emitDraftChange();
    },
    callProducts(newVal) {
      if (newVal) {
        this.defaultCallProducts = JSON.parse(newVal);
        this.costProportionSubmit = JSON.parse(newVal);
      }
    },
    diner_amount() {
      this.emitDraftChange();
    },
    doctors: {
      handler() {
        this.emitDraftChange();
      },
      deep: true,
    },
    colleagues: {
      handler() {
        this.emitDraftChange();
      },
      deep: true,
    },
    costProportionSubmit: {
      handler() {
        this.emitDraftChange();
      },
      deep: true,
    },
  },
  mounted() {
    this.colleagues = [
      {
        user_id: getLocalStorage('user_id'),
        user_name: getLocalStorage('user_name'),
      },
    ];
  },
  methods: {
    // 在这里定义方法
    handleSelectDoctor(data) {
      this.showDoctorSelect = false;
      this.doctors = data.map((item) => {
        return {
          physician_id: item.physician_id,
          physician_name: item.physician_name,
          department_name: item.department_name,
          institution_id: item.institution_id,
          institution_name: item.institution_name,
          professional_title: item.professional_title,
        };
      });
    },
    handleSelectColleague(data) {
      this.colleagues = this.colleagues.concat(
        data.filter(item => item && !this.colleagues.some(colleague => colleague.user_id === item.user_id))
          .map(item => ({
            user_id: item.user_id,
            user_name: item.user_name
          }))
      );
    },
    removeDoctor(index) {
      this.doctors.splice(index, 1);
    },
    removeColleague(index) {
      let newArr = this.colleagues;
      newArr.splice(index, 1);
      this.colleagues = newArr;
    },
    handleChangeCostProportion(index, value) {
      this.costProportionSubmit[index].cost_proportion = Number(value);
    },
    emitDraftChange() {
      this.$emit('draft-change', this.getDraftState());
    },
    getDraftState() {
      return {
        diner_amount: this.diner_amount,
        doctors: JSON.parse(JSON.stringify(this.doctors || [])),
        colleagues: JSON.parse(JSON.stringify(this.colleagues || [])),
        costProportionSubmit: JSON.parse(JSON.stringify(this.costProportionSubmit || [])),
      };
    },
    applyDraftState(draftState = {}) {
      this.diner_amount = draftState.diner_amount || 0;
      this.doctors = JSON.parse(JSON.stringify(draftState.doctors || []));
      this.colleagues = JSON.parse(JSON.stringify(draftState.colleagues || []));
      this.costProportionSubmit = JSON.parse(JSON.stringify(draftState.costProportionSubmit || []));
    },
  },
};
</script>

<style lang="scss" scoped>
.add-expense {
  display: grid;
  gap: 12px;
  padding-bottom: 20px;
}

.expense-section {
  padding: 14px;
  overflow: hidden;
  border: 1px solid rgba(31, 35, 40, 0.04);
  border-radius: 18px;
  background-color: #fff;
  box-shadow: 0 4px 18px rgba(31, 35, 40, 0.05);
}

.expense-section-header {
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.expense-section-title {
  color: #202326;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
}

.expense-section-count {
  min-width: 30px;
  padding: 2px 8px;
  border-radius: 12px;
  color: #7d8085;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  background: #f2f3f5;
}

.expense-balance {
  color: #8b8e93;
  font-size: 11px;
  line-height: 18px;
  white-space: nowrap;
}

.expense-balance strong,
.expense-summary strong {
  color: #aa341b;
  font-weight: 500;
}

.expense {
  margin-top: 6px;
}

.expense ::v-deep .van-cell {
  padding: 8px 0 0;
  display: block;
  background: transparent;
}

.expense ::v-deep .van-cell--required::before {
  top: 8px;
  left: 0;
  line-height: 24px;
}

.expense ::v-deep .van-cell--required .van-field__label {
  padding-left: 11px;
}

.expense ::v-deep .van-cell .van-cell__value {
  border: 1px solid #dcdcdc;
  margin: 6px 0 0;
  padding: 4px 8px;
  border-radius: 8px;
}

.expense-summary {
  padding-top: 8px;
  display: flex;
  justify-content: space-between;
  color: #8b8e93;
  font-size: 12px;
  line-height: 18px;
}

.cost_proportion {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f1f3;
}

.cost-proportion-title {
  color: #646566;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.cost_proportion ::v-deep .van-cell {
  padding: 8px 0 0;
  display: flex;
  align-items: center;
  background: transparent;
}

.cost_proportion ::v-deep .van-cell::after {
  display: none;
}

.cost_proportion ::v-deep .van-field__label {
  width: auto;
}

.cost_proportion ::v-deep .van-cell .van-cell__value {
  max-width: 210px;
  border: 1px solid #dcdcdc;
  margin: 0 0 0 auto;
  padding: 4px 8px;
  border-radius: 8px;
  flex: 0 1 60%;
}

::v-deep .van-checkbox {
  margin-bottom: 10px;
}

.checkbox ::v-deep .van-cell .van-cell__value {
  border: none;
  margin: 0 -8px -18px;
}

::v-deep .van-checkbox-group {
  width: 100%;
}

.people-list {
  margin-top: 2px;
}

.people-action {
  margin-top: 4px;
  text-align: left;
}

.people-action ::v-deep .van-button--info {
  border: none;
}

.input-style {
  min-height: 44px;
  padding: 5px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
}

.input-border {
  min-width: 0;
  display: flex;
  align-items: baseline;
  flex: 1;
  text-align: left;
}

.input-mini-words {
  overflow: hidden;
  margin-left: 10px;
  font-size: 12px;
  color: #a7a6a6;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.delete-icon {
  flex: none;
  padding: 6px;
}
</style>
